import React, { useEffect, FC } from 'react'
import ReactPlayer from 'react-player'
import { v4 as uuidv4 } from 'uuid'
import './viewchallenge.less'
import {
    FacebookIcon,
    FacebookShareButton,
    LinkedinIcon,
    LinkedinShareButton,
    TwitterIcon,
    TwitterShareButton,
    EmailIcon,
    EmailShareButton,
    RedditIcon,
    RedditShareButton,
    WhatsappIcon,
    WhatsappShareButton
} from 'react-share'

const swagIdFacebook = uuidv4()
const swagIdTwitter = uuidv4()
const swagIdLinkedIn = uuidv4();
const swagIdEmail = uuidv4();
const swagIdReddit = uuidv4();
const swagIdWhatsapp = uuidv4();

interface StyleProps {
    subTitleStyle?: CSSProperties
    titleStyle?: CSSProperties
    progressStyle?: CSSProperties
}

interface DataProps {
    viewchallengeSettings?: ChallengeSettingsDto,
    challengedata?: ViewChallengeDataRecord,
    ambassadorprofile?: ViewAmbassadorProfileRecord,
    onAfterSocialShare?: any,
    daysRemaining?: string,
    fundedpercentage?: number,
    socialIcons?: string
}

export type ViewchallengeContentBlockProps = StyleProps & DataProps
// export components as named exports

export const ViewChallengeComponent: FC<ViewchallengeContentBlockProps> = (props: ViewchallengeContentBlockProps) => {


    if (!props.viewchallengeSettings) {
        return (<div className="scoreboard-container"> no title </div>)
    }
    const { scoreboardInstanceSettingsId } = props.viewchallengeSettings;
    const challengeDataList = props.challengedata;
    const ambassadorProfile = props.ambassadorprofile;
    const daysRemaining = props.daysRemaining
    const FundedPercentage = props.fundedpercentage
    const {
        facebook = true,
        twitter = true,
        linkedin = true,
        reddit = true,
        whatsapp = true,
        email = true,
    } = props.socialIcons ? JSON.parse(props.socialIcons) : {};
    //The below code is included to load the latest Twitter Icon however this code is not needed once library is updated
    useEffect(() => {
        const elements = document.querySelectorAll('[aria-label="twitter"]');

        elements.forEach((el) => {
            const elPath = el.getElementsByTagName('path')[0];
            const eLCircle = el.getElementsByTagName('circle')[0];

            if (el && eLCircle) {
                elPath && elPath.removeAttribute('d');
                elPath && elPath.setAttribute("d", "M 41.116 18.375 h 4.962 l -10.8405 12.39 l 12.753 16.86 H 38.005 l -7.821 -10.2255 L 21.235 47.625 H 16.27 l 11.595 -13.2525 L 15.631 18.375 H 25.87 l 7.0695 9.3465 z m -1.7415 26.28 h 2.7495 L 24.376 21.189 H 21.4255 z");

                eLCircle && eLCircle.removeAttribute('fill');
                eLCircle && eLCircle.setAttribute('fill', '#000000');
            }
        });
    });

    return (
        <div>
            <div className='challengeName' tabIndex={0}>{props.viewchallengeSettings.layoutSettings.challengeName}</div>
            <div id="viewChallengeContentBlockId">
                <div className={`scoreboard-id-${scoreboardInstanceSettingsId}`}>
                    <div className='challenge'>
                        {challengeDataList &&
                            (<div className='challenge-wrapper'>
                                <div className='challenge-progress'>
                                    {challengeDataList.VideoFileUrl ?
                                        <div className="challenge-image">
                                            <ReactPlayer width={'100%'} height={'400px'} url={challengeDataList.VideoFileUrl} />
                                        </div> : (challengeDataList.ChallengeImage ? <div className='challenge-image'> <img tabIndex={0}
                                            alt='challenge image'
                                            src={challengeDataList.ChallengeImage}></img> </div> : <></>)
                                    }
                                    <div className='challenge-progress-indicator'>
                                        <div style={{ marginTop: '12px' }}>
                                            <div className="progressbar" tabIndex={0}>
                                                <div
                                                    className="progress-bar"
                                                    role="progressbar"
                                                    aria-valuenow={FundedPercentage}
                                                    aria-valuemin={0}
                                                    aria-valuemax={100}
                                                    style={{ width: `${FundedPercentage}%`, backgroundColor: "#337ab7" }}
                                                >
                                                    <span className="sr-only" >{FundedPercentage}% Complete</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div style={{ padding: '0px' }}>
                                            <div id="summary" className="challenge-donation-wrapper row">
                                                <div tabIndex={0} className="challengeDetails col-align-self-start col-12 col-sm-5 col-md-3 col-lg-3">
                                                    {challengeDataList.ChallengeGoalType !== 'Participation' ?
                                                        <div>
                                                            <p className="detailsTitle" >${challengeDataList.RaisedAmount}</p>
                                                            <p className='detailsDescription'  >raised of ${challengeDataList.GoalAmount} goal </p>
                                                        </div>
                                                        :
                                                        <div>
                                                            <p className="detailsTitle" >{challengeDataList.NumberOfDonations} donated</p>
                                                            <p className='detailsDescription' >out of {challengeDataList.GoalParticipation} donors </p>
                                                        </div>
                                                    }
                                                </div>
                                                <div tabIndex={0} className="challengeDetails col-align-self-start col-12 col-sm-4 col-md-3 col-lg-3">
                                                    {challengeDataList.ChallengeGoalType !== 'Participation' ?
                                                        <div>
                                                            <p className="detailsTitle" >{challengeDataList.NumberOfDonations}</p>
                                                            <p className='detailsDescription'> donors </p>
                                                        </div>
                                                        :
                                                        <div>
                                                            <p className="detailsTitle" >${challengeDataList.RaisedAmount}</p>
                                                            <p className='detailsDescription' > raised </p>
                                                        </div>
                                                    }
                                                </div>
                                                <div tabIndex={0} className="challengeDetails col-align-self-start col-12 col-sm-3 col-md-3 col-lg-3">
                                                    <p className="detailsTitle" >{daysRemaining}</p>
                                                    <p className="detailsDescription" >remaining</p>
                                                </div>
                                                <div style={{ marginTop: '0px' }} className="challengeDetails challengeDetails-sm challengeDetails-md col-align-self-start col-12 col-sm-12 col-md-3 col-lg-3">
                                                    <button tabIndex={0}
                                                        aria-label="give now"
                                                        className="button givenowBtn button-sm button-md"
                                                        role="button"
                                                        data-toggle="dropdown"
                                                        aria-haspopup="true"
                                                        aria-expanded="false"
                                                        disabled={false}
                                                    >
                                                        <a href={challengeDataList.DonationUrl} target="_blank" rel="noreferrer">
                                                            {' '}
                                                            GIVE NOW{' '}
                                                        </a>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="challenge-description" tabIndex={0}>{challengeDataList.ChallengeDescription}</div>
                                <div className='challenge-share'>
                                    {facebook && <FacebookShareButton
                                        className="socialShareBtn facebookBtn"
                                        onShareWindowClose={
                                            props.onAfterSocialShare &&
                                            props.onAfterSocialShare.bind(
                                                null,
                                                `${challengeDataList.CreateShareApiUrl}&swag=${swagIdFacebook}&sn=${challengeDataList.FacebookSnId}`
                                            )
                                        }
                                        quote={`Hey friends! Help me make a difference by contributing to ${challengeDataList.ChallengeName}. I've Created this Challenge to support the ${imod.cms.scoreboards.siteName}'s giving initiative! Every little bit counts!\n`}
                                        url={`${challengeDataList.SocialShareUrl}&swag=${swagIdFacebook}`}
                                    >
                                        <FacebookIcon size={32} round={true} />
                                    </FacebookShareButton>}
                                    {twitter && <TwitterShareButton
                                        className="socialShareBtn twitterBtn"
                                        onShareWindowClose={
                                            props.onAfterSocialShare &&
                                            props.onAfterSocialShare.bind(
                                                null,
                                                `${challengeDataList.CreateShareApiUrl}&swag=${swagIdTwitter}&sn=${challengeDataList.TwitterSnId}`
                                            )
                                        }
                                        title={`Hey friends! Help me make a difference by contributing to ${challengeDataList.ChallengeName}. I've Created this Challenge to support the ${imod.cms.scoreboards.siteName}'s giving initiative! Every little bit counts!\n`}
                                        url={`${challengeDataList.SocialShareUrl}&swag=${swagIdTwitter}`}
                                    >
                                        <TwitterIcon size={32} round={true} />
                                    </TwitterShareButton>}
                                    {linkedin && <LinkedinShareButton
                                        className="socialShareBtn linkedinBtn"
                                        onShareWindowClose={() => {
                                            if (props.onAfterSocialShare)
                                                props.onAfterSocialShare(
                                                    `${challengeDataList.CreateShareApiUrl}&swag=${swagIdLinkedIn}&sn=${challengeDataList.LinkedInSnId}`
                                                );
                                        }}
                                        title={`Hey friends! Help me make a difference by contributing to ${challengeDataList.ChallengeName}. I've Created this Challenge to support the ${imod.cms.scoreboards.siteName}'s giving initiative! Every little bit counts!\n`}
                                        url={`${challengeDataList.SocialShareUrl}&swag=${swagIdLinkedIn}&sn=${challengeDataList.LinkedInSnId}`}
                                    >
                                        <LinkedinIcon size={32} round={true} />
                                    </LinkedinShareButton>}
                                    {reddit && <RedditShareButton
                                        className="socialShareBtn redditBtn"
                                        onShareWindowClose={() => {
                                            if (props.onAfterSocialShare)
                                                props.onAfterSocialShare(
                                                    `${challengeDataList.CreateShareApiUrl}&swag=${swagIdReddit}&sn=${challengeDataList.RedditSnId}`
                                                );
                                        }}
                                        title={`Hey friends! Help me make a difference by contributing to ${challengeDataList.ChallengeName}. I've Created this Challenge to support the ${imod.cms.scoreboards.siteName}'s giving initiative! Every little bit counts!\n`}
                                        url={`${challengeDataList.SocialShareUrl}&swag=${swagIdReddit}&sn=${challengeDataList.RedditSnId}`}
                                    >
                                        <RedditIcon size={32} round={true} />
                                    </RedditShareButton>}
                                    {whatsapp && <WhatsappShareButton
                                        className="socialShareBtn whatsappBtn"
                                        onShareWindowClose={() => {
                                            if (props.onAfterSocialShare)
                                                props.onAfterSocialShare(
                                                    `${challengeDataList.CreateShareApiUrl}&swag=${swagIdWhatsapp}&sn=${challengeDataList.WhatsappSnId}`
                                                );
                                        }}
                                        title={`Hey friends! Help me make a difference by contributing to ${challengeDataList.ChallengeName}. I've Created this Challenge to support the ${imod.cms.scoreboards.siteName}'s giving initiative! Every little bit counts!\n`}
                                        url={`${challengeDataList.SocialShareUrl}&swag=${swagIdWhatsapp}&sn=${challengeDataList.WhatsappSnId}`}
                                    >
                                        <WhatsappIcon size={32} round={true} />
                                    </WhatsappShareButton>}
                                    {email && <EmailShareButton
                                        className="socialShareBtn"
                                        onShareWindowClose={() => {
                                            if (props.onAfterSocialShare)
                                                props.onAfterSocialShare(
                                                    `${challengeDataList.CreateShareApiUrl}&swag=${swagIdEmail}&sn=${challengeDataList.EMailSnId}`
                                                );
                                        }}
                                        subject={`Help me meet my Donation Challenge: ${challengeDataList.ChallengeName}`}
                                        body={`Hey friends! Help me make a difference by contributing to ${challengeDataList.ChallengeName}. I've Created this Challenge to support the ${imod.cms.scoreboards.siteName}'s giving initiative! Every little bit counts!\n`}
                                        url={`${challengeDataList.SocialShareUrl}&swag=${swagIdEmail}&sn=${challengeDataList.EMailSnId}`}
                                    >
                                        <EmailIcon size={32} round={true} />
                                    </EmailShareButton>}

                                </div>
                            </div>)}
                        {(ambassadorProfile && <div className='challenge-ambassador challenge-ambassador-sm row'>
                            {ambassadorProfile.imageUrl !== '' ? (
                                <div className=' challenge-ambassador-image col-align-self-start col-12 col-sm-7 col-md-5 col-lg-4' tabIndex={0}>
                                    <img className='img-fluid rounded-circle' tabIndex={0} src={ambassadorProfile.imageUrl} /></div>
                            ) : <div className='col-0'></div>}
                            <div className={ambassadorProfile.imageUrl !== '' ? 'challenge-ambassador-details col-align-self-start col-12 col-sm-12 col-md-9 col-lg-9' : 'challenge-ambassador-noimagedetails col-align-self-start col-12 col-sm-12 col-md-12 col-lg-12'}>
                                <span tabIndex={0} className='ambassadorDetailsName'>{ambassadorProfile.name}</span>
                                <div className='ambassadorDetailsClass'> <span>{ambassadorProfile.degree ? (ambassadorProfile.classYear ? ambassadorProfile.degree + " -" : ambassadorProfile.degree) : ''}   </span> <span>{ambassadorProfile.classYear ? ambassadorProfile.classYear : ''}</span></div>
                                <div className='ambassadorBio'>{ambassadorProfile.bio}</div>
                            </div>
                        </div>)}

                    </div>
                </div>
            </div>
        </div>
    )
}


export default ViewChallengeComponent